import { useStytchMemberSession } from "@stytch/react/b2b";
import { Navigate } from "react-router-dom";
import LoginScreen from "../screens/LoginScreen";

const Authenticate = () => {
  const { session } = useStytchMemberSession();

  if (session) {
    return <Navigate to="/" />;
  }

  return <LoginScreen />;
};

export default Authenticate;
